/* eslint-disable no-shadow */
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getUserReservations } from '../../../../../ui-kitchen/src/api';
import { reservationsTransform } from '../../../../../ui-kitchen/src/api/resyApiTransformer';
import { setReservationToBeModified } from '../../../../../ui-kitchen/src/reducers/userSlice';
import Logger from '../../../../../ui-kitchen/src/utils/logger';

const PATHS = {
  RESERVATIONS: '/account/reservations-and-notify',
  CHANGE_CANCEL: '/account/change-cancel',
};

const ReservationDeepLinkController = ({ setReservationToBeModified }) => {
  const { bookOnBehalfOf, resyToken } = useParams();
  const navigate = useNavigate();
  const tokenKey = bookOnBehalfOf ? 'concierge_resy_token' : 'resy_token';

  useEffect(() => {
    const getReservation = () => {
      getUserReservations({ [tokenKey]: resyToken, book_on_behalf_of: bookOnBehalfOf || false })
        .then(
          (data) => {
            const reservationData = reservationsTransform(data);
            if (!!reservationData && reservationData.length > 0) {
              const reservation = reservationData[0];
              reservation.dateTime = moment(`${reservation.day} ${reservation.time}`, 'YYYY-MM-DD HH:mm:ss').format('llll');
              setReservationToBeModified(reservation);
              navigate(PATHS.CHANGE_CANCEL);
            } else {
              navigate(PATHS.RESERVATIONS);
            }
          },
          (error) => {
            if (error && error.status !== 404 && error.status !== 419) {
              Logger.error('[ReservationDeepLinkController] Error', error);
            }
            navigate(PATHS.RESERVATIONS);
          }
        ).catch((error) => {
          Logger.error('[ReservationDeepLinkController] Error:', error);
          navigate(PATHS.RESERVATIONS);
        });
    };

    getReservation();
  }, []);

  return null;
};

ReservationDeepLinkController.propTypes = {
  setReservationToBeModified: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setReservationToBeModified,
};

ReservationDeepLinkController.displayName = 'ReservationDeepLinkController';
export { ReservationDeepLinkController as ComponentUnderTest };
export default connect(null, mapDispatchToProps)(ReservationDeepLinkController);
